'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('containersShow', {
    url: '/containers/:id/show?wm&windows&container_token&share_token&splitpane&remote_host',
    template: '<containers-show></containers-show>',
    // templateUrl: 'app/containersShow/containersShow.html',
    // controller: 'ContainersShowCtrl',
    authenticate: false,
    reloadOnSearch: false,
  });
}
